// extracted by mini-css-extract-plugin
export var numberInputContainer = "_6b-0";
export var startPickingButton = "_6b-1";